import React from 'react'

import NavLink from '../Routes/NavLink'
import { spaces } from '../../core/controllers/Spaces'

export default class SpecificSpacesSelect extends React.Component {
    constructor(props) {
        super(props);

        var colSize = 2;
        var title = "Select a Space:";
        var sortID = 0;
        var buildingId = 0;
        var disabled = "";

        if(this.props.columnSize !== undefined)
        {
            colSize = this.props.columnSize;

        } if(this.props.title !== undefined)
        {
            title = this.props.title;
        } if(this.props.sortID !== undefined)
        {
            sortID = this.props.sortID;
        }
        if(this.props.buildingId) {
            buildingId = this.props.buildingId;
        }
        if(this.props.disabled !== undefined)
        {
            disabled = this.props.disabled
        }

        this.options = {
            columnSize: "col-sm-" + colSize,
            title: title,
            sortID: sortID,
            disabled: disabled
        }

        this.state = {
            data: null,
            buildingId: buildingId
        }
    }

    componentDidMount() {
    }

    componentWillUpdate(nextProps, nextState) {
        if(nextProps.sortID === undefined) {
            this.options.sortID = nextProps.sortID;
        } else {
            this.options.sortID = nextProps.sortID;
        }

        if(nextProps.buildingId != 0 && nextProps.buildingId !== undefined && nextProps.buildingId != this.state.buildingId) {
            spaces.getSpacesBasedOnBuilding(nextProps.buildingId, this);
            nextState.buildingId = nextProps.buildingId;
        }
    }

    render(){
        // #  Implement functionality to have tenant select list auto select selectID passed in, if one does
        const dataList = this.state.data;
        const options = this.options;
        return (
            <div class={options.columnSize}>
                <small>{options.title}</small>
                <select disabled={options.disabled} class="form-control" value={options.sortID} onChange={this.props.onChange}>
                    <option value="0">Select a Space</option>
                    {dataList != null && (
                        dataList.map(function(data, index){
                            if(data.space_data == null) {
                                return;
                            } else {
                                return <option value={data.space.space_id} key={data.space.space_id}>
                                    {data.space_data.title}
                                </option>
                            }
                        })
                    )}
                </select>
            </div>
        )
    }
};


// WEBPACK FOOTER //
// app/components/Spaces/SpecificSpacesSelect.jsx